export function renderFormFactory(compile, templates, getValueFromScope, locale, getPathFromModel) {
  return function renderForm(parentModel) {
    return new Promise(resolve => {
      if (!parentModel) {
        compile(`<ewc-message-center ec-bg="deep" icon="empty-set" label="${locale['fbTree.selectOneNode']}"></ewc-message-center>`).then(() => resolve());
        return;
      }
      const path = getPathFromModel(parentModel);
      const parentScope = {};
      const parentName = path.split('.').slice(-1)[0]; // 'CAB.TREE.data' -> 'data'
      parentScope[parentName] = getValueFromScope(parentModel);

      compile(templates[path], path, parentScope).then(() => {
        resolve();
      });
    });
  };
}
